<page-toolbar title="Navigation" [pageActions]="pageActions"></page-toolbar>
<page-content [noPadding]="true">
  <div class="menu-buttons" *ngIf="buttons?.length > 1">
    <div class="menu-button" *ngFor="let button of buttons; let i = index" (click)="openNavigation(i)" [ngClass]="{'active': selectedIndex === i}">
      {{button.title}}
    </div>
  </div>

  <div class="container" *ngIf="activeField">
    <div class="header">
      <div class="title">{{ buttons[selectedIndex]?.title }}</div>
      <div class="actions" *ngIf="superadmin">
        <button (click)="openAppPicker()" matTooltip="{{'packages.installedApps.addApplication' | translate}}" *ngIf="package.compositionIds.length && availableApps?.length">
          <mat-icon>library_add</mat-icon>
        </button>
        <button (click)="resetAppOrders()" matTooltip="{{'packages.installedApps.resetTip'| translate}}">
          <mat-icon>refresh</mat-icon>
        </button>
        <button (click)="openAppCreator()" matTooltip="{{'packages.installedApps.addNewApplication' | translate}}">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <div class="dropdown" *ngIf="buttons[selectedIndex]?.field === 'installedWidgetIds'">
      <div class="title" *ngIf="!!package.screen.fixedWidgetId">{{'packages.installedApps.selectFixed' | translate}}</div>
      <div class="inner">
        <mat-select [(ngModel)]="package.screen.fixedWidgetId" placeholder="{{'packages.installedApps.selectFixed' | translate}}" (selectionChange)="setFixed($event)">
          <mat-option *ngFor="let app of items" [value]="getApp(app)?._id">{{ getTitle(app) }}</mat-option>
        </mat-select>
        <button (click)="setFixed()" matTooltip="{{'packages.installedWidgets.hints.removeFixed' | translate}}">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <div class="sub-header">
      <div class="icon">{{'general.icon' | translate}}</div>
      <div class="title">{{'general.title' | translate}}</div>
      <div class="state">{{'general.state' | translate}}</div>
      <div class="drag">
        <mat-icon>keyboard_arrow_up</mat-icon>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </div>
      <div class="created">{{ 'general.created' | translate }}</div>
      <div class="actions"></div>
    </div>

    <div *ngIf="!!items?.length" cdkDropList [cdkDropListData]="items" class="list" (cdkDropListDropped)="drop($event)"
         [class.withFixed]="buttons[selectedIndex]?.field === 'installedWidgetIds'">
      <ng-container *ngFor="let item of items">
        <div class="item" cdkDrag cdkDragBoundary=".list" (click)="edit($event, item)" [ngClass]="{ 'no-edit': getApp(item).packageId !== packageId }">
          <ibex-icon class="icon" [name]="getIcon(item)" variant="blank"></ibex-icon>
          <div class="drag-placeholder" *cdkDragPlaceholder></div>
          <div class="title">{{ getTitle(item) }}<mat-icon *ngIf="isSecured(item)">group</mat-icon></div>
          <div class="times" *ngIf="buttons[selectedIndex]?.field === 'installedTVWidgetIds'" [innerHTML]="getTimes(item)"></div>
          <div class="type">{{ getType(item) }}</div>
          <div class="state"><navigation-active-state [item]="item" [type]="activeField" [package]="package" [app]="getApp(item)"></navigation-active-state></div>
          <div class="drag" cdkDragHandle matTooltip="{{'packages.installedApps.dragTip'| translate}}"><mat-icon>drag_indicator</mat-icon></div>
          <div class="created" *ngIf="!!item?.created">{{item?.created | date:'dd.MM.YYYY'}}</div>
          <div class="actions">
            <button *ngIf="getContentType(item) === 'memory'" (click)="resetHighscore($event, item)" [matTooltip]="'packages.navigation.resetHighscore' | translate"><mat-icon>restore</mat-icon></button>
            <button *ngIf="getApp(item).packageId === packageId" (click)="edit($event, item)" [matTooltip]="'packages.navigation.editMenupoint' | translate"><mat-icon>edit</mat-icon></button>
            <button *ngIf="getApp(item).packageId === packageId" (click)="remove($event, item)" [matTooltip]="'packages.navigation.removeMenupoint' | translate"><mat-icon>delete</mat-icon></button>
            <ibex-checkbox (click)="toggleMasterPackageApp(item._id)" [checked]="!isDisabledInherited(item)"
                           [tooltip]="'packages.installedApps.' + (!isDisabledInherited(item) ? 'disable' : 'enable') + 'InheritedApp'| translate"
                           *ngIf="getApp(item).packageId !== packageId"></ibex-checkbox>
            <ibex-checkbox *ngIf="getApp(item).packageId === packageId" (click)="togglePackageApp(getApp(item))" [checked]="!getApp(item)?.disabled"
                           [tooltip]="'packages.installedApps.' + (!getApp(item)?.disabled ? 'disable' : 'enable') + 'App'| translate"></ibex-checkbox>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</page-content>
